import { useState } from "react";
import { toast } from "react-toastify";
import axiosProtected from "../../../../../api/config/baseWithToken";

const VIDEO = /\.(mp4|mov|webm|m4v)(\?|$)/i;

// Factory pictures for the merchant's quality check: add several at once,
// remove any. The first one is also saved as the old single factory_picture.
export default function FactoryPicturesField({ pictures, onChange }) {
  const [uploading, setUploading] = useState(0);

  const add = async (files) => {
    const list = Array.from(files || []);
    if (!list.length) return;
    setUploading(list.length);
    const added = [];
    for (const file of list) {
      try {
        const form = new FormData();
        form.append("media", file);
        const { data } = await axiosProtected.post("/store/upload", form);
        if (data?.media) added.push({ url: data.media, mime_type: file.type });
      } catch (err) {
        toast.error(`${file.name} could not be uploaded`);
      }
      setUploading((n) => n - 1);
    }
    onChange([...pictures, ...added]);
  };

  return (
    <div style={{ marginTop: 8 }}>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        {pictures.map((item, i) => (
          <div key={item.url} style={{ position: "relative", width: 64, height: 64 }}>
            {item.mime_type?.startsWith("video") || VIDEO.test(item.url) ? (
              <a
                href={item.url}
                target="_blank"
                rel="noreferrer"
                style={{
                  display: "grid",
                  placeItems: "center",
                  width: 64,
                  height: 64,
                  borderRadius: 8,
                  background: "#f3eefc",
                  color: "#4f2498",
                  textDecoration: "none",
                }}
              >
                ▶
              </a>
            ) : (
              <a href={item.url} target="_blank" rel="noreferrer">
                <img
                  src={item.url}
                  alt={`Factory shot ${i + 1}`}
                  style={{ width: 64, height: 64, objectFit: "cover", borderRadius: 8, border: "1px solid #eee" }}
                />
              </a>
            )}
            <button
              type="button"
              onClick={() => onChange(pictures.filter((p) => p.url !== item.url))}
              aria-label={`Remove picture ${i + 1}`}
              style={{
                position: "absolute",
                top: -6,
                right: -6,
                width: 20,
                height: 20,
                borderRadius: "50%",
                border: 0,
                background: "#303030",
                color: "#fff",
                fontSize: 12,
                lineHeight: "20px",
                cursor: "pointer",
              }}
            >
              ×
            </button>
          </div>
        ))}
      </div>
      <label style={{ display: "inline-block", marginTop: 8, color: "#7f56d9", fontWeight: 600, fontSize: 14, cursor: "pointer" }}>
        <input
          hidden
          type="file"
          multiple
          accept="image/*, video/*"
          onChange={(e) => {
            add(e.target.files);
            e.target.value = "";
          }}
        />
        {uploading > 0 ? `Uploading ${uploading}…` : pictures.length ? "Add more pictures" : "Upload pictures*"}
      </label>
    </div>
  );
}
